import { h, render, Fragment } from 'preact'
import { useEffect, useState } from 'preact/hooks'
import styled from 'styled-components'
import { Card, Loader, EntryRow } from '../components'
import { RowDescription } from '../style'

import { HiChevronLeft, HiChevronRight, HiOutlineRefresh } from 'react-icons/hi'

const PAGE_SIZE = 5

const Footer = styled(Card.Footer)`
  align-items: center;
  gap: 12px;
`

const Pagination = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

const PaginationButton = styled(Card.FooterAction)`
  --button-padding-y: 8px;
  --button-padding-x: 10px;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  min-height: 36px;
`

const PageInfo = styled.div`
  ${RowDescription}
  min-width: 46px;
  text-align: center;
  font-weight: 600;
`

const NewEntryAction = styled(Card.FooterAction)`
  --button-padding-y: 8px;
  --button-padding-x: 14px;

  margin-left: auto;
  min-height: 36px;
  white-space: nowrap;
`

export const Entries = ({ state, send }) => {
  const { context } = state
  const { entries } = context
  const [page, setPage] = useState(0)

  const pageCount = Math.max(1, Math.ceil(entries.length / PAGE_SIZE))
  const currentPage = Math.min(page, pageCount - 1)
  const firstEntry = currentPage * PAGE_SIZE
  const visibleEntries = entries.slice(firstEntry, firstEntry + PAGE_SIZE)
  const hasPreviousPage = currentPage > 0
  const hasNextPage = currentPage < pageCount - 1

  useEffect(() => {
    if (page !== currentPage) {
      setPage(currentPage)
    }
  }, [currentPage, page])

  const previousPage = () => {
    if (hasPreviousPage) {
      setPage(currentPage - 1)
    }
  }

  const nextPage = () => {
    if (hasNextPage) {
      setPage(currentPage + 1)
    }
  }

  return (
    <Card.Wrapper>
      <Card.Inner footer>
        <Card.Header>
          <Card.Title>Entries</Card.Title>
          <Card.HeaderAction>
            <HiOutlineRefresh size={20} onClick={() => send('REFRESH')} />
          </Card.HeaderAction>
        </Card.Header>
        <Card.Content>
          {state.matches('loadingEntries') ? (
            <Loader />
          ) : (
            visibleEntries.map((entry) => (
              <EntryRow
                key={entry.id}
                data={entry}
                onClick={() => send('ENTRY', { entry })}
              />
            ))
          )}
        </Card.Content>
      </Card.Inner>
      <Footer>
        <Pagination>
          <PaginationButton
            color={hasPreviousPage ? 'grey' : 'disabled'}
            onClick={previousPage}
            title="Previous page"
          >
            <HiChevronLeft size={18} />
          </PaginationButton>
          <PageInfo>{`${currentPage + 1}/${pageCount}`}</PageInfo>
          <PaginationButton
            color={hasNextPage ? 'grey' : 'disabled'}
            onClick={nextPage}
            title="Next page"
          >
            <HiChevronRight size={18} />
          </PaginationButton>
        </Pagination>
        <NewEntryAction onClick={() => send('NEW_ENTRY')}>New Entry</NewEntryAction>
      </Footer>
    </Card.Wrapper>
  )
}
